import { api } from '@/config/api';

export type DepartmentKind = 'sales' | 'tech' | 'ops' | 'support' | 'medical' | 'legal' | 'custom';

export interface Department {
  deptUid: string;
  companyUid: string;
  name: string;
  description?: string;
  kind: DepartmentKind;
  isDefault: boolean;
  color: string;
  icon: string;
  order: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateDepartmentInput {
  name: string;
  description?: string;
  kind?: DepartmentKind;
  isDefault?: boolean;
  color?: string;
  icon?: string;
  order?: number;
}

export type UpdateDepartmentInput = Partial<CreateDepartmentInput>;

const BASE = '/slighter_crm/departments';

export const departmentsService = {
  list: async (): Promise<Department[]> => (await api.get(BASE)).data,
  create: async (input: CreateDepartmentInput): Promise<Department> => (await api.post(BASE, input)).data,
  update: async (deptUid: string, patch: UpdateDepartmentInput): Promise<Department> =>
    (await api.patch(`${BASE}/${deptUid}`, patch)).data,
  remove: async (deptUid: string): Promise<{ ok: boolean }> =>
    (await api.delete(`${BASE}/${deptUid}`)).data,
  reorder: async (deptUids: string[]): Promise<{ ok: boolean }> =>
    (await api.patch(`${BASE}/reorder`, { deptUids })).data,
};
